import * as Sentry from '@sentry/browser';

// Phase 17 brief item 1 — Sentry JS SDK init. DSN + release ride in
// via Vite at build time (VITE_SENTRY_DSN, VITE_SENTRY_RELEASE). If
// either is missing we no-op so dev builds without keys don't ship a
// broken init or chatter to a default DSN.
export function initSentry(): void {
    const dsn = import.meta.env['VITE_SENTRY_DSN'] as string | undefined;
    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        release: (import.meta.env['VITE_SENTRY_RELEASE'] as string | undefined) ?? undefined,
        environment: (import.meta.env['VITE_SENTRY_ENVIRONMENT'] as string | undefined) ?? 'production',
        tracesSampleRate: 0.1,
        sendDefaultPii: false,
        beforeBreadcrumb(breadcrumb) {
            if (typeof breadcrumb.message === 'string') {
                breadcrumb.message = scrub(breadcrumb.message);
            }
            return breadcrumb;
        },
        beforeSend(event) {
            if (event.request?.url) {
                event.request.url = scrub(event.request.url);
            }
            return event;
        },
    });
}

const EMAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
const PHONE = /(?<![\w\d])(?:\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}(?![\w\d])/g;
const IPV4 = /\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\b/g;

function scrub(input: string): string {
    return input.replace(EMAIL, '[email]').replace(PHONE, '[phone]').replace(IPV4, '[ip]');
}
